/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useLanguage } from "LanguageContext";

export default function AnalysisLegend() {
  const { t } = useLanguage();
  const listStyle = css`
    display: flex;
    gap: 15px;
    margin-top: 32px;
  `;
  const itemStyle = css`
    display: flex;
    align-items: center;
    gap: 4px;
  `;

  return (
    <ul css={listStyle}>
      <li css={itemStyle}>
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="5" cy="5" rx="5" ry="5" fill="#15CB4A"></ellipse>
        </svg>
        <span>
        { t("analysis_legend_good") }
        </span>
      </li>
      <li css={itemStyle}>
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="5" cy="5" rx="5" ry="5" fill="#A3CDED"></ellipse>
        </svg>
        <span>
        { t("analysis_legend_neutral") }
        </span>
      </li>
      <li css={itemStyle}>
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="5" cy="5" rx="5" ry="5" fill="#FFC400"></ellipse>
        </svg>
        <span>
        { t("analysis_legend_bad") }
        </span>
      </li>
      <li css={itemStyle}>
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="5" cy="5" rx="5" ry="5" fill="#EAEEF0"></ellipse>
        </svg>
        <span>
        { t("analysis_legend_not_applicable") }
        </span>
      </li>
    </ul>
  );
}
